module.exports = __webpack_public_path__ + "img/Ideasoft.f9970580.png";